import DefaultScreen from './DefaultScreen';

export default DefaultScreen;
